import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
let _cache = null;

export const useAppSettings = () => {
  const [settings, setSettings] = useState(_cache || { subscription_price_eur: 7.99, subscription_duration_days: 30 });

  useEffect(() => {
    if (_cache) { setSettings(_cache); return; }
    axios.get(`${API}/settings`)
      .then(r => { _cache = r.data; setSettings(r.data); })
      .catch(() => {});
  }, []);

  return settings;
};
